import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const analyzeSEO = createAsyncThunk(
    'seo/analyzeSEO',
    async ({ text, keyword }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/analyze-seo', 'POST', { text, keyword });
            if (response.error) {
                return rejectWithValue(response.message || response.error);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error analyzing SEO');
        }
    }
);

const seoSlice = createSlice({
    name: 'seo',
    initialState: {
        metrics: null, // { score, wordCount, density, keywordCount }
        categories: null, // { core: [], lsi: [], questions: [] }
        keyword: '',
        loading: false,
        error: null,
    },
    reducers: {
        clearSEO: (state) => {
            state.metrics = null;
            state.categories = null;
            state.keyword = '';
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(analyzeSEO.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(analyzeSEO.fulfilled, (state, action) => {
                state.loading = false;
                state.metrics = action.payload.metrics;
                state.categories = action.payload.categories;
                state.keyword = action.payload.keyword;
            })
            .addCase(analyzeSEO.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

export const { clearSEO } = seoSlice.actions;
export default seoSlice.reducer;
